import {PromoCode} from '@domain/model/Account/PromoCode/PromoCode';
import {PromoCodeRepository, RedeemPromoCodeCommand} from '@domain/model/Account/PromoCode/PromoCodeRepository';

const RedeemPromoCode =
  (repository: PromoCodeRepository) =>
  ({promoCode, device, service}: RedeemPromoCodeCommand): Promise<PromoCode | void> => {
    return repository.redeemPromoCode({promoCode, device, service});
  };

export {RedeemPromoCode};
